module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [(_vm.u) ? _c('div', {
    staticClass: "uk-padding"
  }, [_c('ul', {
    staticClass: "uk-breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/users"
    }
  }, [_vm._v("Gebruikers")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'UserDetail',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.u.displayName))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'UserEdit',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_vm._v("Bewerken")])], 1)]), _vm._v(" "), _c('h1', [_vm._v("Gegevens Bewerken")]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.u.displayName),
      expression: "u.displayName"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "Volledige naam"
    },
    domProps: {
      "value": (_vm.u.displayName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.u, "displayName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.u.firstname),
      expression: "u.firstname"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "Voornaam"
    },
    domProps: {
      "value": (_vm.u.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.u, "firstname", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.u.lastname),
      expression: "u.lastname"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "Naam"
    },
    domProps: {
      "value": (_vm.u.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.u, "lastname", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.u.email),
      expression: "u.email"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "disabled": true,
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.u.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.u, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.role),
      expression: "role"
    }],
    staticClass: "uk-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.role = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.userRoles), function(r, i) {
    return _c('option', {
      domProps: {
        "value": i
      }
    }, [_vm._v(_vm._s(r))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('button', {
    staticClass: "uk-button uk-button-primary",
    on: {
      "click": _vm.update
    }
  }, [(!_vm.loading) ? _c('span', [_vm._v("Save")]) : _vm._e(), (_vm.loading) ? _c('div', {
    attrs: {
      "uk-spinner": ""
    }
  }) : _vm._e()])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fb2d24b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/CORE/pages/UserEdit.vue
// module id = 523
// module chunks = 1